import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserGoalCheckCalendar from '../usercomponents/UserGoalCheckCalendar';
import '../Style/UserSocialCell.css';
import UserRankBadge from '../components/rank/UserRankBadge';
import '../Style/goalCard.css';
import ReactionBar from '../components/ReactionBar';
import ReactionVaultBanner from '../components/ReactionVaultBanner';
import { useReactions } from '../hooks/useReactions';
import ReactionSocialProof from '../components/ReactionSocialProof';
import ReactionUsersModal from '../components/ReactionUsersModal';

const UserSocialCell = ({ user, viewedMonth, onMonthNav, view }) => {
  const navigate = useNavigate();

  const displayDate = viewedMonth ? new Date(viewedMonth.year, viewedMonth.month) : new Date();

  const todayStr = new Date().toLocaleDateString('en-CA');
  const reactionData = useReactions(user.id);
  const [reactionModalOpen, setReactionModalOpen] = useState(false);
  const [reactionModalUsers, setReactionModalUsers] = useState([]);

  const totalChecksToday =
    user.goals?.reduce((acc, goal) => {
      const dailyCount = goal.checkDates?.filter((d) => d.split('T')[0] === todayStr).length || 0;
      return acc + dailyCount;
    }, 0) || 0;

  const isTrending = totalChecksToday >= (view === 'following' ? 1 : 2);

  const monthYearString = displayDate.toLocaleString('default', {
    month: 'long',
    year: 'numeric',
  });

  const checkDateStrings = (user.calendarData || [])
    .map((item) => item.checkDate || item.date)
    .filter(Boolean);

  return (
    <div className="activity-cell-container">
      {/* LEFT: Monthly Activity */}
      <div className="social-left-col">
        <div className="month-nav social-month-nav-wrapper">
          <button
            className="nav-arrow-btn"
            onClick={(e) => {
              e.stopPropagation();
              onMonthNav(user.id, 'PREV');
            }}
          >
            ‹
          </button>

          <div className="month-display">
            <span className="month-label">{monthYearString}</span>
          </div>

          <button
            className="nav-arrow-btn"
            onClick={(e) => {
              e.stopPropagation();
              onMonthNav(user.id, 'NEXT');
            }}
          >
            ›
          </button>
        </div>

        <div className="calendar-mini-wrapper">
          <UserGoalCheckCalendar
            checkDates={checkDateStrings}
            month={displayDate.getMonth()}
            year={displayDate.getFullYear()}
          />
        </div>
      </div>

      {/* CENTER & RIGHT: Clickable Link to Profile */}
      <div style={{ display: 'contents' }} onClick={() => navigate(`/profile/${user.id}`)}>
        {/* CENTER: Identity */}
        <div className="social-center-col">
          <div className="social-avatar-wrapper">
            <div className="social-avatar-gradient">
              {user.profilePicUrl ? (
                <img src={user.profilePicUrl} alt={user.firstName} className="social-avatar-img" />
              ) : (
                <div className="social-avatar-inner">{user.firstName?.[0]}</div>
              )}
            </div>

            <div className="social-trophy">
              <UserRankBadge
                rank={user.rank}
                className="social-trophy"
                customStyle={{ width: '40px', height: '40px', objectFit: 'contain' }}
              />
            </div>
          </div>

          {isTrending && (
            <div className="social-trending-badge">🔥 {totalChecksToday} CHECKS TODAY</div>
          )}

          <h4 className="social-name ">
            {user.firstName} {user.lastName}
          </h4>

          {/* CENTER INFO ONLY */}
          <div className="social-reaction-vault-only" onClick={(e) => e.stopPropagation()}>
            <ReactionVaultBanner lifetimeCounts={reactionData.lifetimeCounts} />
          </div>

          <div className="social-progress-container">
            <div className="social-progress-bar">
              <div
                style={{
                  width: `${user.rankProgress || 0}%`,
                  height: '100%',
                  background: 'linear-gradient(90deg, #6366f1, #a855f7)',
                }}
              />
            </div>

            <div className="social-rank-labels">
              <span>{user.rank || 'Bronze I'}</span>
              <span>{user.totalXp?.toLocaleString() || 0} XP</span>
            </div>
          </div>
        </div>

        {/* RIGHT: Current Focus */}
        <div className="social-right-col">
          <span className="social-label">Current Focus</span>

          <div className="social-goal-list">
            {user.goals
              ?.filter((goal) => {
                const today = new Date().toLocaleDateString('en-CA');
                return goal.checkDates?.some((dateStr) => dateStr.split('T')[0] === today);
              })
              .slice(0, 7)
              .map((goal) => (
                <div key={goal.id} className="social-goal-row">
                  <span className="social-goal-title">{goal.goalTitle || goal.title}</span>
                  <span className="social-goal-count">{goal.checkDates?.length || 0}🔥</span>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* BOTTOM LEFT: Social action reactions */}
      <div className="social-bottom-reactions" onClick={(e) => e.stopPropagation()}>
        <ReactionSocialProof
          reactionUsers={reactionData.reactionUsers}
          onOpen={(users) => {
            setReactionModalUsers(users);
            setReactionModalOpen(true);
          }}
        />
        <ReactionBar
          todayCounts={reactionData.todayCounts}
          myReactionsToday={reactionData.myReactionsToday}
          handleToggle={reactionData.handleToggle}
          isSelf={reactionData.isSelf}
          REACTION_EMOJIS={reactionData.REACTION_EMOJIS}
          processing={reactionData.processsing}
        />
      </div>
      <ReactionUsersModal
        isOpen={reactionModalOpen}
        users={reactionModalUsers}
        onClose={() => setReactionModalOpen(false)}
      />
    </div>
  );
};

export default UserSocialCell;
